import { useState, ReactElement } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { SnackbarState } from '../types';

/**
 * Hook for managing snackbar notifications consistently across components
 */
export const useSnackbar = () => {
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: '',
    severity: 'success',
  });

  const showSnackbar = (
    message: string,
    severity: 'success' | 'info' | 'warning' | 'error' = 'success'
  ) => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const closeSnackbar = () => {
    setSnackbar(prevState => ({
      ...prevState,
      open: false,
    }));
  };

  // Adding the SnackbarComponent function
  const SnackbarComponent = (): ReactElement => {
    return (
      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    );
  };

  return {
    snackbar,
    showSnackbar,
    closeSnackbar,
    SnackbarComponent,
  };
};
